// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__39Bh9","requiredAsterisk":"Info_requiredAsterisk__2kK0s"};